import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({ selector: '[pcpClickOutside]' })
export class ClickOutsideDirective {
    @Output() pcpClickOutside = new EventEmitter<void>();

    constructor(private element: ElementRef<Element>,) {
    }

    @HostListener('document:click', ['$event'])
    confirmOnClick(event: MouseEvent) {
        const target = event.target as Node | null;
        if (target != this.element.nativeElement && !this.element.nativeElement.contains(target)) {
            this.pcpClickOutside.emit();
        }
    }

}
